var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.displayLightbox)?_c('img-modal'):_vm._e(),_c('Home')],1)}
var staticRenderFns = []

export { render, staticRenderFns }